import { CoreState } from '../../../models/state/core-state.model';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class StateLoadedFromCache implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.stateLoadedFromCache]: (localState: CoreState, stateLoadedFromCache: boolean) => {
      localState.stateLoadedFromCache = stateLoadedFromCache;
    }
  };
}
